// FETCH ALL PROPERTIES FROM WASHING_DC DETAILS
export const FETCH_WASHING_DC_DETAILS_REQUEST_DK = 'FETCH_WASHING_DC_DETAILS_REQUEST_DK';
export const FETCH_WASHING_DC_DETAILS_SUCCESS_DK = 'FETCH_WASHING_DC_DETAILS_SUCCESS_DK';
export const FETCH_WASHING_DC_DETAILS_FAILURE_DK = 'FETCH_WASHING_DC_DETAILS_FAILURE_DK';

export const FETCH_GRN_NO_BY_WASHING_DC_NO_REQUEST_DK = 'FETCH_GRN_NO_BY_WASHING_DC_NO_REQUEST_DK';
export const FETCH_GRN_NO_BY_WASHING_DC_NO_SUCCESS_DK = 'FETCH_GRN_NO_BY_WASHING_DC_NO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_WASHING_DC_NO_FAILURE_DK = 'FETCH_GRN_NO_BY_WASHING_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM WASHING_DC DETAILS
export const FETCH_WASHING_DC_DETAILS_DC_NO_REQUEST_DK = 'FETCH_WASHING_DC_DETAILS_DC_NO_REQUEST_DK';
export const FETCH_WASHING_DC_DETAILS_DC_NO_SUCCESS_DK = 'FETCH_WASHING_DC_DETAILS_DC_NO_SUCCESS_DK';
export const FETCH_WASHING_DC_DETAILS_DC_NO_FAILURE_DK = 'FETCH_WASHING_DC_DETAILS_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM WASHING_DC DETAILS BY ID
export const FETCH_WASHING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_WASHING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_WASHING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_WASHING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_WASHING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_WASHING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR WASHING_DC DETAILS
export const CREATE_WASHING_DC_DETAILS_REQUEST_DK = 'CREATE_WASHING_DC_DETAILS_REQUEST_DK';
export const CREATE_WASHING_DC_DETAILS_SUCCESS_DK = 'CREATE_WASHING_DC_DETAILS_SUCCESS_DK';
export const CREATE_WASHING_DC_DETAILS_FAILURE_DK = 'CREATE_WASHING_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_WASHING_DC_DETAILS_DK = 'CREATE_USER_FORM_WASHING_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR WASHING_DC DETAILS
export const UPDATE_WASHING_DC_DETAILS_REQUEST_DK = 'UPDATE_WASHING_DC_DETAILS_REQUEST_DK';
export const UPDATE_WASHING_DC_DETAILS_SUCCESS_DK = 'UPDATE_WASHING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_WASHING_DC_DETAILS_FAILURE_DK = 'UPDATE_WASHING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE WASHING_DC_DETAILS
export const FETCH_SINGLE_WASHING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_WASHING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_WASHING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_WASHING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_WASHING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_WASHING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR WASHING_DC DETAILS
export const DELETE_WASHING_DC_DETAILS_REQUEST_DK = 'DELETE_WASHING_DC_DETAILS_REQUEST_DK';
export const DELETE_WASHING_DC_DETAILS_SUCCESS_DK = 'DELETE_WASHING_DC_DETAILS_SUCCESS_DK';
export const DELETE_WASHING_DC_DETAILS_FAILURE_DK = 'DELETE_WASHING_DC_DETAILS_FAILURE_DK';

export const FETCH_WASHING_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_WASHING_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_WASHING_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_WASHING_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_WASHING_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_WASHING_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const WASHING_DC_DETAILS_USERFORM_RESET_DK = 'WASHING_DC_DETAILS_USERFORM_RESET_DK';
